<template>
  <div>
    <div class="" v-if="billingSuccess == false">
      <form
        style="width: 90%; margin-left: auto; margin-right: auto;"
        method="POST"
        @submit="createBilling"
      >
        <h3 class="header_style">Billing Plan</h3>
        <hr class="hr_styling" />
        <div class="">
          <!-- Input User Email address -->
          <div class="form-group row">
            <label class="col-lg-4 col-form-label" for="emailValidation"
              >Device Id</label
            >
            <div class="col-lg-8">
              <input
                type="text"
                class="form-control form-control-lg"
                id="emailValidation"
                v-model="usersDeviceId"
                placeholder="Input customer's Device ID"
                @change="getUserByEmail"
              />
            </div>
          </div>

          <!-- Active User -->
          <div class="form-group row">
            <label class="col-lg-4 col-form-label" for="activatedUser"
              >Subscription-Active User</label
            >
            <div class="col-lg-8">
              <select
                v-model="activatedUser"
                class="form-control form-control-lg"
                id="activatedUser"
                @change="confirmCardActivation"
              >
                <option
                  v-for="(user, index) in activeUserList"
                  :key="index"
                  :value="user.customerid"
                  >{{ user.name }}</option
                >
              </select>
            </div>
          </div>

          <!-- Select method of Payment -->
          <div class="form-group row" v-show="true">
            <label class="col-lg-4 col-form-label" for="paymentMethod"
              >Select payment method</label
            >
            <div class="col-lg-8">
              <select
                v-model="paymentMethod"
                class="form-control form-control-lg"
                id="paymentMethod"
                @change="UpdatePaymentMethod"
              >
                <option
                  v-for="(method, index) in paymentMethodList"
                  :key="index"
                  :value="method"
                  >{{ method.paymenttype }}</option
                >
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-lg-4 col-form-label" for="price">Amount(₦)</label>
            <div class="col-lg-8">
              <input
                type="number"
                class="form-control form-control-lg"
                id="price"
                v-model="regParams.price"
                placeholder="0.00"
                @change="updateMonthlyCharge"
              />
            </div>
          </div>

          <div class="form-group row">
            <label
              class="col-lg-4 col-form-label"
              for="numberOfTimesPaymentIsMade"
              >Payments Count</label
            >
            <div class="col-lg-8">
              <input
                type="number"
                class="form-control form-control-lg"
                id="numberOfTimesPaymentIsMade"
                v-model="regParams.numberOfTimesPaymentIsMade"
                placeholder="0"
              />
            </div>
          </div>

          <div class="form-group row">
            <label
              class="col-lg-4 col-form-label"
              for="monthlyRecurringChargeDate"
              >Charge date</label
            >
            <div class="col-lg-8">
              <DatePicker
                v-model="regParams.monthlyRecurringChargeDate"
                id="monthlyRecurringChargeDate"
                class="date-upload"
                placeholder="dd-mm-yy"
                :default-value="new Date()"
                :disabled-date="disabledBeforeTodayAndAfterAWeek"
              ></DatePicker>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-4 col-form-label" for="duration"
              >Payment Duration (in Months)</label
            >
            <div class="col-lg-8">
              <input
                type="number"
                class="form-control form-control-lg"
                id="duration"
                v-model="regParams.duration"
                placeholder="0"
                @change="updateMonthlyCharge"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-4 col-form-label" for="monthlyCharge"
              >Monthly Charge(₦)</label
            >
            <div class="col-lg-8">
              <input
                type="number"
                class="form-control form-control-lg monthly_charge"
                id="monthlyCharge"
                v-model="regParams.monthlyCharge"
                disabled
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              class="btn btn-info btn-block btn-lg"
              @click="createBilling"
            >
              Create Billing
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { Autocomplete, Form, FormItem } from "element-ui";
import DatePicker from "vue2-datepicker";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import moment from "moment";
import { isEmpty } from "element-ui/src/utils/util";

var getSearchParams = k => {
  var p = {};
  var LocationAddr = window.location.toString().split("?")[1];
  LocationAddr.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(s, k, v) {
    p[k] = v;
  });
  return k ? p[k] : p;
};

export default {
  name: "billing-schedule",
  components: {
    DatePicker,
    "el-autocomplete": Autocomplete,
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose
  },
  data() {
    return {
      billingSuccess: false,
      usersDeviceId: "",
      activatedUser: "",
      paymentMethod: {},
      regParams: {
        installationId: "",
        duration: "",
        numberOfTimesPaymentIsMade: "",
        monthlyRecurringChargeDate: "",
        price: "",
        monthlyCharge: ""
      },
      errorsResult: {},
      installationList: [],
      activeUserList: [],
      checkPaymentVerification: [],
      paymentMethodList: []
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {},
  methods: {
    updateMonthlyCharge() {
      let calc = this.monthlyCharge;
      calc = this.regParams.price / this.regParams.duration;
      this.regParams.monthlyCharge = Math.ceil(calc).toFixed(2);
    },
    getContacts() {
      const HTTP = this.$httpUtils.instance;
      let ctx = this;
      let filter = {
        where: {
          and: [
            { CID: { neq: null } },
            {
              or: [
                { status: "requested" },
                { status: "scheduled" },
                { status: "commissioned" },
                { status: "completed" }
              ]
            }
          ]
        },
        include: ["deviceRequest", "locations", "user"]
      };
      const url = `/installations?filter=${JSON.stringify(filter)}`;
      HTTP.get(url)
        .then(response => {
          ctx.installationList = response.data.map(x => ({
            ...x,
            value:
              x && x.deviceRequest
                ? `${x.name} (${x.CID ? x.CID : x.solarKitIds}) `
                : null
          }));
        })
        .catch(error => {
          console.log("error", error);
        });
    },

    disabledBeforeTodayAndAfterAWeek(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today;
    },
    validateReg() {
      var errors = [];
      for (let [field, value] of Object.entries(this.regParams)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        switch (field) {
          case "duration":
            if (value === "null" || value === "NaN" || isEmpty(value)) {
              errors[field] = "Duration cannot be empty.";
            }
            break;
          case "numberOfTimesPaymentIsMade":
            if (value === "null" || value === "NaN" || isEmpty(value)) {
              errors[field] = "Number of payment made cannot be empty.";
            }
            break;
          case "monthlyRecurringChargeDate":
            if (
              value === "null" ||
              value === "" ||
              isEmpty(value) ||
              value === "Invalid date"
            ) {
              errors[field] = "Charge date cannot be empty.";
            }
            break;
          case "price":
            if (value === "null" || value === "NaN" || isEmpty(value)) {
              errors[field] = "Amount cannot be empty.";
            }
            break;
          case "monthlyCharge":
            if (value === "null" || value === "NaN" || isEmpty(value)) {
              errors[field] = "Monthly charge cannot be empty.";
            }
            break;
          default:
            break;
        }
      }
      this.errorsResult = errors;
    },
    createBilling(e) {
      e.preventDefault();
      const keys = Object.keys(this.regParams);
      this.regParams.monthlyRecurringChargeDate = moment(
        this.regParams.monthlyRecurringChargeDate
      ).format();

      this.validateReg();
      var errorLength = Object.keys(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      }

      keys.forEach((key, index) => {
        if (!["installation", "monthlyRecurringChargeDate"].includes(key)) {
          this.regParams[key] = parseInt(this.regParams[key]);
        }
      });
      const HTTP = this.$httpUtils.BILLING_HTTP;
      // REMAINING ASPECT NOW
      const url = "billing/create-billing";
      let totalAmountUserPaid =
        this.regParams.numberOfTimesPaymentIsMade *
        this.regParams.monthlyCharge;
      console.log("totalAmountUserPaid", totalAmountUserPaid);
      let payloadBody = {
        monthlycharge: this.regParams.monthlyCharge,
        totalamountpaid: totalAmountUserPaid,
        duration: this.regParams.duration,
        deviceid: parseInt(this.usersDeviceId),
        totalprice: this.regParams.price,
        numberoftimespaymentismade: this.regParams.numberOfTimesPaymentIsMade,
        userid: parseInt(this.activeUserList[0].onbardinguser),
        payerid: parseInt(this.activatedUser),
        monthlyrecurringchargedate: this.regParams.monthlyRecurringChargeDate
      };
      console.log("payloadBody", payloadBody);
      HTTP.post(url, payloadBody)
        .then(res => {
          console.log("response", res);
          this.showSuccessMsg({ message: "Device setup successfully!" });
          location.reload();
        })
        .catch(error => {
          this.showErrorMsg({ message: error.response.data.error.message });
        });
    },
    getUserByEmail() {
      const HTTP = this.$httpUtils.BILLING_HTTP;
      let userDeviceID = parseInt(this.usersDeviceId);
      const url = `billing/get-user-data/${userDeviceID}`;
      HTTP.get(url)
        .then(res => {
          this.showSuccessMsg({ message: "User's details confirmed" });
          let responseData = res.data.data;
          this.activeUserList = responseData;
        })
        .catch(error => {
          this.showErrorMsg({ message: error.response.data.error.message });
        });
    },
    confirmCardActivation() {
      const HTTP = this.$httpUtils.BILLING_HTTP;
      const url = `billing/bank-users/${this.activatedUser}`;
      HTTP.get(url)
        .then(res => {
          let recurringPaymentDetails = res.data.data;
          this.showSuccessMsg({ message: "Users' Payment plan confirmed" });
          this.paymentMethodList = recurringPaymentDetails;
        })
        .catch(error => {
          this.showErrorMsg({ message: error.response.data.error.message });
        });
    },
    UpdatePaymentMethod() {
      const HTTP = this.$httpUtils.BILLING_HTTP;
      const url = `billing/update-payment-method`;
      let bodyData = {
        id: parseInt(this.paymentMethod.recurrnigid),
        customerid: parseInt(this.activatedUser)
      };
      HTTP.post(url, bodyData)
        .then(res => {
          this.showSuccessMsg({
            message: `${this.paymentMethod.paymenttype} has been Activated`
          });
        })
        .catch(error => {
          this.showErrorMsg({ message: error.response.data.error.message });
        });
    },
    installationSearch(queryString, cb) {
      let installationList = this.installationList;
      var results = queryString
        ? installationList.filter(installation =>
            this.createFilter(queryString, installation)
          )
        : installationList;
      cb(results);
    },
    createFilter(queryString, installation) {
      // console.log({ name: installation });
      return (
        `${installation.name} - ${installation.CID}`
          .toLowerCase()
          .indexOf(queryString.toLowerCase()) > -1
      );
    },
    contactSelected(installation) {
      let ctx = this;
      let { form } = ctx;
      let { deviceRequest, user, locations } = installation;
      let paymentModel = deviceRequest.paymentModel;
      this.regParams.installationId = installation.id;
    }
  },
  mounted() {},
  created() {
    this.getContacts();
  }
};
</script>

<style scoped>
h3.header_style {
  font-weight: 600;
  font-size: 24px;
  text-align: left;
}
.row {
  margin-bottom: 20px;
}
/* .installation {
  background-color: #727272;
  border: none;
  border-radius: 6px;
} */
.monthly_charge {
  background-color: #e3e7ecd0;
}

.date-upload {
  background: transparent;
  border-radius: 3px;
  border: none;
  width: 100%;
  height: 100%;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #727272;
}

.form-group label {
  font-size: 14px;
  color: #606266;
}
.p-signup__form-link:last-child {
  margin-bottom: 20px;
}
input[type="text"] {
  /* background-image: url("../../assets/img/profile2.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
input[type="phone-number"] {
  /* background-image: url("../../assets/img/smartphone-call.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
input[type="address"] {
  /* background-image: url("../../assets/img/placeholder.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
select {
  /* background-color: #ebeff2 !important; */
  text-indent: 0px;
}
input[type="password"] {
  /* background-image: url("../../assets/img/key2.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
input[type="checkbox"] {
  height: 0rem;
  margin-right: 20px;
}
.p-signup__form-submit {
  margin-bottom: 30px;
}
.uk-offcanvas-bar {
  width: 90vw !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/users/new-billing.vue